import { TEAMS_PLATFORM_CF_TYPE } from '@atlassian/jira-platform-field-config/src/index.tsx';
import type { TEAM_SUPPORTED_TYPES } from '../types.tsx';

export const teamSupportedTypes: TEAM_SUPPORTED_TYPES[] = [TEAMS_PLATFORM_CF_TYPE];
